import React, { useState, useRef, useEffect } from "react";
import manuscriptImage from '../Img/manuscript_img.png';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import Select from "react-dropdown-select";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Manuscript = () => {
  const login = JSON.parse(localStorage.getItem("isLoggedIn")) || "";
  const [formData, setFormData] = useState({
    name: login.name || "",
    email: login.email || "",
    phone: login.mobile || "",
    country: login.country || "",
    address: login.address,
    articleTitle: "",
    articleCategory: "",
    file: null,
    selectedPlan: null,
    fee: null,
    iscouponapplied: null,
    coupon: null,
  });


  const [data, setData] = useState({
    name: login.name || "",
    email: login.email || "",
    phone: login.mobile || "",
    country: login.country || "",
    address: login.address,
    user_id: login.id,
    manuscriptNumber: "",
  });

  const [errors, setErrors] = useState({});
  const firstFieldRef = useRef(null);
  const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [plan, setPlans] = useState([])


  const fetchDataPlan = async () => {
    try {
      const response = await fetch(`https://backend.impactjournal.co.in/plan`)
      const res = await response.json();
      const activePlans = res.filter(plan => plan.status === "Active");
      console.log(res);
      setPlans(activePlans);
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (firstFieldRef.current) firstFieldRef.current.focus();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handlePay = async (referenceNumber) => {
    try {
      const response = await fetch("https://backend.impactjournal.co.in/processingfee", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: login.name,
          email: login.email,
          phone: login.mobile,
          country: login.country,
          address: login.address,
          user_id: login.id,
          fee: formData.fee || 1199,
          manuscriptNumber: referenceNumber,
          iscouponapplied: formData.iscouponapplied || false,
          coupon: formData.coupon || null,
          selectedPlan: {
            article_category: formData.articleCategory
          }
        }),
      });

      const data = await response.json();
      openRazorpay(data.razorpay_order, data.order_id);
      if (response.ok) {
        toast.success("Submitted successfully!");
        setFormData({
          name: login.name || "",
          email: login.email || "",
          phone: login.mobile || "",
          country: login.country || "",
          address: login.address,
          user_id: login.id,
          manuscriptNumber: "",
        });
      } else {
        alert("Submission failed: " + data.message);
      }
    } catch (error) {
      console.error("Submission error:", error);
      toast.error("An error occurred while submitting.");
    } finally {
      setLoading(false); // Hide spinner
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ];

    if (file && !allowedTypes.includes(file.type)) {

      setErrors(prev => ({ ...prev, file: "Only PDF files are allowed" }));
    } else {
      setFormData(prev => ({ ...prev, file }));
      setErrors(prev => ({ ...prev, file: "" }));
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "Name is required";
    if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) newErrors.email = "Valid email is required";
    if (!formData.phone || !/^\d{12}$/.test(formData.phone)) newErrors.phone = "Valid 10-digit phone number is required";
    if (!formData.country) newErrors.country = "Country is required";
    if (!formData.address) newErrors.address = "Address is required";
    if (!formData.articleTitle) newErrors.articleTitle = "Article title is required";
    if (!formData.articleCategory) newErrors.articleCategory = "Article category is required";
    if (!formData.file) newErrors.file = "PDF file is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    if (!isLoggedIn) {
      toast.error("You must be logged in to submit a manuscript.");
      return;
    }

    if (!validate()) return;

    setLoading(true); // Show spinner

    const formPayload = new FormData();
    formPayload.append("name", formData.name);
    formPayload.append("email", formData.email);
    formPayload.append("phone", formData.phone);
    formPayload.append("country", formData.country);
    formPayload.append("address", formData.address);
    formPayload.append("articleTitle", formData.articleTitle);
    formPayload.append("articleCategory", formData.articleCategory);
    formPayload.append("file", formData.file);

    try {
      const response = await fetch("https://backend.impactjournal.co.in/manuscript", {
        method: "POST",
        body: formPayload
      });

      const result = await response.json();

      if (response.ok) {
        localStorage.setItem("isSubmitManuscript", JSON.stringify(result.newManuscript));
        toast.success("Manuscript submitted successfully!");
        handlePay(result.data.referenceNumber)
        setFormData({
          name: "",
          email: "",
          phone: "",
          country: "",
          address: "",
          articleTitle: "",
          articleCategory: "",
          file: null
        });

        if (fileInputRef.current) {
          fileInputRef.current.value = null;
        }
      } else {
        alert(result.message || "Failed to submit.");
      }
    } catch (error) {
      console.error("Submission error:", error);
      alert("Something went wrong while submitting.");
    } finally {
      setLoading(false); // Hide spinner
    }
  };

  const openRazorpay = (razorpayOrder, order_id) => {
    const options = {
      key: "rzp_live_Rkjr9d9h0LQfaV",
      amount: razorpayOrder.amount,
      currency: razorpayOrder.currency,
      name: "Impact",
      description: "Order Payment",
      order_id: razorpayOrder.id,
      handler: async function (response) {
        const verifyRes = await fetch("https://backend.impactjournal.co.in/processingfee/verify", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            razorpay_order_id: response.razorpay_order_id,
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_signature: response.razorpay_signature,
          }),
        });

        const verifyData = await verifyRes.json();
        if (verifyData.success) {
          window.location.href = `/payment-success/${order_id}`; // ✅ Redirect on success
        } else {
          window.location.href = `/payment-failed/${order_id}`; // ❌ Redirect on failure
        }
      },
      prefill: {
        name: "Impact",
        email: "support@accormed.in",
        contact: "9326623800",
      },
      theme: { color: "#d1060c" },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  const handleApplyCoupon = async () => {
    if (!formData.coupon) {
      toast.error("Please enter a coupon");
      return;
    }

    try {
      const res = await fetch(`https://backend.impactjournal.co.in/coupon/check/${formData.coupon}`);
      console.log(res);
      const result = await res.json();
      const data = result.couponData
      // if (!res.ok || !data.success) {
      //   toast.error(data.message || "Invalid or expired coupon.");
      //   return;
      // }
      if (res.status === 400) {
        toast.error(result.message || "Invalid or expired coupon.");
        return;
      }

      const originalFee = formData?.fee || 1199;
      let discountedFee = originalFee;

      if (data.percentage_offer) {
        discountedFee = Math.round(originalFee - (originalFee * data.percentage_offer / 100));
      } else if (data.price_offer) {
        discountedFee = Math.max(0, originalFee - data.price_offer);
      }

      setFormData((prev) => ({
        ...prev,
        fee: discountedFee,
        iscouponapplied: true,
        coupon: formData.coupon
      }));

      toast.success("Coupon applied successfully!");
    } catch (err) {
      console.error("Coupon apply error:", err);
      toast.error("Failed to apply coupon.");
    }
  };

  const renderError = (field) =>
    errors[field] && <div className="form-register-error-impact">{errors[field]}</div>;

  const categoryOptions = plan.map((p) => ({
    label: `${p.article_category} (₹${p.final_price})`,
    value: p.article_category,
    planData: p
  }));


  useEffect(() => {
    fetchDataPlan();
  }, [])

  return (
    <>
      {/* <ToastContainer position="top-center" autoClose={3000} /> */}
      <div className="register-main-pm manuscript-main-pm">
        <div className="manuscript-img-div-pm">
          <img src={manuscriptImage} alt="Manuscript Submission Illustration" />
        </div>

        <div className="register-section-pm manuscript-top-pm">
          <div className="form-register-wrapper-impact">
            <h2>Manuscript Submission Form</h2>
            <div className="form-register-step-impact">

              <div className="form-register-input-group-impact">
                <label htmlFor="name" className="form-register-label-impact">Full Name</label>
                <input
                  ref={firstFieldRef}
                  id="name"
                  name="name"
                  placeholder="Enter your full name"
                  value={formData.name}
                  onChange={handleChange}
                  className="form-register-input-impact"
                />
                {renderError("name")}
              </div>

              <div className="form-register-input-group-impact">
                <label htmlFor="email" className="form-register-label-impact">Email Address</label>
                <input
                  id="email"
                  name="email"
                  placeholder="Enter your email address"
                  value={formData.email}
                  onChange={handleChange}
                  className="form-register-input-impact"
                />
                {renderError("email")}
              </div>
              <div className="form-register-input-group-impact">
                <label htmlFor="phone" className="form-register-label-impact">Phone Number</label>

                <PhoneInput
                  country={'in'}
                  value={formData.phone}
                  onChange={(phone) => setFormData({ ...formData, phone })}
                  inputClass="form-register-input-impact"
                  inputProps={{
                    name: 'phone',
                    required: true,
                    id: 'phone'
                  }}
                />

                {renderError("phone")}
              </div>

              <div className="form-register-input-group-impact">
                <label htmlFor="country" className="form-register-label-impact">Country of Residence</label>
                <input
                  id="country"
                  name="country"
                  placeholder="Enter your country"
                  value={formData.country}
                  onChange={handleChange}
                  className="form-register-input-impact"
                />
                {renderError("country")}
              </div>

              <div className="form-register-input-group-impact">
                <label htmlFor="address" className="form-register-label-impact">Full Address</label>
                <input
                  id="address"
                  name="address"
                  placeholder="Enter your full address"
                  value={formData.address}
                  onChange={handleChange}
                  className="form-register-input-impact"
                />
                {renderError("address")}
              </div>

              <div className="form-register-input-group-impact">
                <label htmlFor="articleTitle" className="form-register-label-impact">Title of the Manuscript</label>
                <input
                  id="articleTitle"
                  name="articleTitle"
                  placeholder="Enter the article title"
                  value={formData.articleTitle}
                  onChange={handleChange}
                  className="form-register-input-impact"
                />
                {renderError("articleTitle")}
              </div>

              <div className="form-register-input-group-impact form-select-impact">
                <label htmlFor="articleCategory" className="form-register-label-impact">Article Category</label>
                {/* <Select
                  options={categoryOptions}
                  values={
                    formData.articleCategory
                      ? [{ label: formData.articleCategory, value: formData.articleCategory }]
                      : []
                  }
                  onChange={(selected) => {
                    handleChange({
                      target: {
                        name: "articleCategory",
                        value: selected[0]?.value || ""
                      }
                    });
                  }}
                  placeholder="Select Category"
                  className="form-register-input-impact form-register-input-select-impact"
                /> */}
                <Select
                  options={categoryOptions}
                  values={
                    formData.articleCategory
                      ? [{ label: `${formData.articleCategory} (₹${formData.fee || ''})`, value: formData.articleCategory }]
                      : []
                  }
                  onChange={(selected) => {
                    const planObj = selected[0]?.planData;
                    setFormData(prev => ({
                      ...prev,
                      articleCategory: selected[0]?.value || "",
                      selectedPlan: planObj,
                      fee: planObj ? Number(planObj.final_price) : 1199
                    }));
                  }}
                  placeholder="Select Category"
                  className="form-register-input-impact form-register-input-select-impact"
                />

                {renderError("articleCategory")}
              </div>

              <div className="form-register-input-group-impact">
                <label htmlFor="file" className="form-register-label-impact">Upload Manuscript (PDF/Word File)</label>
                <input
                  id="file"
                  type="file"
                  accept=".pdf, .doc, .docx, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                  className="form-register-input-impact"
                />
                {renderError("file")}
              </div>
              <div className="form-register-input-group-impact" style={{ display: "flex", gap: "10px" }}>
                <input
                  type="text"
                  name="coupon"
                  placeholder="Enter coupon code"
                  value={formData.coupon}
                  onChange={handleChange}
                  disabled={formData.iscouponapplied}
                  className="form-register-input-impact"
                  style={{ flex: 1 }}
                />
                <button
                  type="button"
                  onClick={handleApplyCoupon}
                  disabled={formData.iscouponapplied}
                  className="form-register-btn-impact form-register-btn-submit-impact"
                  style={{ whiteSpace: "nowrap" }}
                >
                  {formData.iscouponapplied ? "Applied" : "Apply"}
                </button>
              </div>

              <div className="form-register-navigation-impact">
                <button
                  onClick={handleSubmit}
                  className="form-register-btn-impact form-register-btn-submit-impact"
                  disabled={loading}
                >
                  {loading ? (
                    <span className="spinner"></span>
                  ) : (
                    `Submit & Pay ${formData.fee ? "₹"+formData.fee : ""}`
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Manuscript;
